import { render, staticRenderFns } from "./LoginIcon.vue?vue&type=template&id=56bed5c0&scoped=true&"
import script from "./LoginIcon.vue?vue&type=script&lang=js&"
export * from "./LoginIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoginIcon.vue?vue&type=style&index=0&id=56bed5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bed5c0",
  null
  
)

export default component.exports